/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Routes, Route, useNavigate, useLocation, Navigate } from 'react-router-dom';
import { useFetchOrder } from '../../hooks/useFetchOrder'; // Hook será usado nos filhos
import { GetOrders } from '../../components/GetOrders';
import { SelectOrder } from '../../components/SelectOrder';
import { ValidationService } from '../../components/ValidationService';
import { Order } from '../../types/types';
import Loading from '../../components/Loading';

const GetOrdersStep = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const orderId = urlParams.get('order_id');
    if (orderId) {
      sessionStorage.removeItem('searchedOrderId');
      sessionStorage.removeItem('searchedDocument');
      sessionStorage.setItem('pedidoEcommerce', orderId);
      navigate(`/selecionar`, { replace: true });
    }
  }, []);

  const handleFetchAndNavigate = (orderId: string, document: string) => {
    sessionStorage.removeItem('pedidoEcommerce');
    sessionStorage.setItem('searchedOrderId', orderId);
    sessionStorage.setItem('searchedDocument', document);
    navigate(`/selecionar`);
  };

  return <GetOrders fetchOrder={handleFetchAndNavigate} />;
};

const SelectOrderStep = () => {
  const navigate = useNavigate();
  const { order, loading, error, statuses, fetchOrderByEcommerceId, fetchOrderByGarDocument, setStatuses } = useFetchOrder();
  const [errorGeneric, setError] = useState<string>();

  useEffect(() => {
    const ecommerceId = sessionStorage.getItem('pedidoEcommerce');
    const garId = sessionStorage.getItem('searchedOrderId');
    const document = sessionStorage.getItem('searchedDocument');

    if (ecommerceId) {
      fetchOrderByEcommerceId(ecommerceId);
    } else if (garId && document) {
      fetchOrderByGarDocument(garId, document);
    } else {
      navigate('/', { replace: true });
    }
  }, []);

  useEffect(() => {
    if (order && order[0]?.codigo === 265) {
      setError('Erro ao buscar pedidos. Tente novamente.');
    }
  }, [order]);

  const handleSchedule = (selectedOrder: Order | null) => {
    if (selectedOrder) {
      sessionStorage.setItem('selectedOrderForValidation', JSON.stringify(selectedOrder));
      navigate('/validar');
    } else {
      console.error('Nenhum pedido selecionado.');
    }
  };

  const handleCancelSchedule = (orderId: string) => {
    const updatedStatuses = { ...statuses, [orderId]: false };
    setStatuses(updatedStatuses);
  };

  if (loading) return <Loading loading={loading} />;
  if (error || errorGeneric) {
    return (
      <div className='flex flex-col gap-10'>
        <p className='text-feedback-negative text-xl'>{error || errorGeneric}</p>
        <a
          href='/'
          className='flex items-center justify-center max-w-60 h-10 bg-ins-blue text-white font-bold rounded-lg'>
          Voltar
        </a>
      </div>
    )
  }
  return (
    <SelectOrder
      orders={order ? [order] : []}
      statuses={statuses}
      onSchedule={handleSchedule}
      onCancelSchedule={handleCancelSchedule}
    />
  );
};

const ValidationStep = () => {
  const location = useLocation();

  let orderForValidation: Order | null = location.state?.selectedOrder;

  if (!orderForValidation) {
    const storedOrderJSON = sessionStorage.getItem('selectedOrderForValidation');
    if (storedOrderJSON) {
      orderForValidation = JSON.parse(storedOrderJSON);
    }
  }

  if (!orderForValidation) {
    return <Navigate to="/" replace />;
  }

  return <ValidationService order={orderForValidation} />;
};

export const Scheduling = () => {
  return (
    <div className='max-w-full md:max-w-[1295px] w-full md:mt-12 mt-0 mx-auto md:px-4 bg-white md:bg-transparent'>
      <Routes>
        <Route index element={<GetOrdersStep />} />
        <Route path="selecionar" element={<SelectOrderStep />} />
        <Route path="validar" element={<ValidationStep />} />
      </Routes>
    </div>
  );
};
